import styled from 'styled-components'

export const ResponsiveImage = styled.img<{
    $width?: string
    $height?: string
}>``
